import React from "react";
import "./Us.css";

const Us = () => {
    return (
        <div className="info">
            <p>
                Cuatro amigos comenzaron hace unos años un grupo musical, pero siendo amantes de los instrumentos musicales y
                necesitando dinero para pagar sus alquileres iniciaron un emprendimiento que poco a poco fue creciendo: Win-Guitars
            </p>
        </div>
    )
}

export default Us;